import { useEffect } from 'react';
import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import { isEnterprisePlan, isProfessionalPlan } from '@gonfalon/billing/subscriptions';

import { resetIntercomInstance } from './resetIntercomInstance';
import type { IntercomFlowType } from './types';

export const useUpdateIntercomFlow = (): { flowName: IntercomFlowType } => {
  const { subscription } = useAccountContext();
  let intercomFlowName: IntercomFlowType;
  if (isEnterprisePlan(subscription)) {
    intercomFlowName = 'enterprise';
  } else if (isProfessionalPlan(subscription)) {
    intercomFlowName = 'pro';
  } else {
    intercomFlowName = 'self-serve';
  }
  useEffect(() => {
    resetIntercomInstance({ flowName: intercomFlowName });
  }, [intercomFlowName, subscription]);

  return { flowName: intercomFlowName };
};
